import React from 'react';
import PropTypes from 'prop-types';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { color } from '@deerplusofficial/pos-helper';
import { withRouter } from '@deerplusofficial/pos-hoc';
import { ButtonBase } from '@deerplusofficial/pos-components';
import withResetPos from '../../assist/withResetPos';
import actions from '../../actions';

export const Container = styled(ButtonBase)`
  display: block;
  padding: 22px 32px;
  font-size: 16px;
  color: ${props => (props.active ? '#ffffff' : color.text.secondary)};
`;

class MenuCell extends React.PureComponent {
  static propTypes = {
    to: PropTypes.string,
  };

  static defaultProps = {
    to: '',
  };

  onClick = () => {
    const { history, toggleDrawer, resetPos, to } = this.props;
    resetPos();
    toggleDrawer();
    history.push(to);
  };

  render() {
    const { to, history, children } = this.props;

    return (
      <Container
        active={to === history.location.pathname}
        onClick={this.onClick}
      >
        {children}
      </Container>
    );
  }
}

const { toggle: toggleDrawer } = actions.drawer;

export default fp.compose(
  withRouter(),
  withResetPos(),
  connect(
    null,
    { toggleDrawer }
  )
)(MenuCell);



// WEBPACK FOOTER //
// ./src/components/Drawer/MenuCell.js